Vendd.Scripts.load(function () {

    var defOptions = {
        navigation: true,
        pagination: true,
        items: 3,
        slideSpeed: 600,
        scrollPerPage: true,
        paginationSpeed: 600,
        addClassActive: true,
        navigationText: ["<span class='icon icon-arrow-light-left'></span>", "<span class='icon icon-arrow-light-right'></span>"],
        autoPlay: 3000,
        lazyLoad: false
    };

    function initOwlSlider(container, options) {

        if ($(container).length > 0) {

            var $wrapper = $(container).closest('.x-slider');
            //var timeout = $wrapper.data('timeout') ? $wrapper.data('timeout') : false;
            //var speed = $wrapper.data('speed') ? $wrapper.data('speed') : 600;


            if (!$wrapper.data('init'))
                return;

            //options.autoPlay = timeout;
            //options.slideSpeed = speed;
            //options.paginationSpeed = speed;

            var opts = $.extend({}, defOptions, options);

            if ($wrapper.data('detailed-pager')) {
                opts.afterUpdate = function () {
                    assignPagerValues($wrapper);
                };
                opts.afterInit = function () {
                    assignPagerValues($wrapper);
                };
            }

            if ($(container).parent().hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {

                opts.afterMove = opts.afterMove || function () {
                    setTimeout(function () { $('img', $wrapper).trigger('lazyload'); }, defOptions.slideSpeed);
                };
                $("img", $wrapper).lazyload().trigger('lazyload');
            }

            container.owlCarousel(opts);
        }
    }

    initOwlSlider($('.news-slider > ul'), {
        singleItem: true,
        rewindSpeed: 1500,
        autoPlay: true,
        navigation: false
    });

    initOwlSlider($('.x-article-list.x-slider > ul'), {
         items: 4,
         itemsDesktop: [1200, 4],
         itemsDesktopSmall: [960, 3],
         itemsTablet: [768, 2],
         itemsMobile: [479, 1],
         autoPlay: false,
         rewindNav: false,
         mouseDrag: false,
         touchDrag: true,
         navigation: false
    });

    initOwlSlider($('.inline-banners .x-promo-list > ul'), {
        items: 3,
        itemsDesktop: [1200, 3],
        itemsDesktopSmall: [960, 3],
        itemsTablet: [768, 2],
        itemsMobile: [479, 1],
        autoPlay: false,
        rewindNav: false,
        mouseDrag: false,
        touchDrag: true,
        navigation: true,
        pagination: false,
        onTranslated: showElement($('.img-fade-in:not(.shown),.text-fade-in:not(.shown)'))
   });


    initOwlSlider($('.landing-page .x-partner-list > ul'), {
        items: 3,
        itemsDesktop: [1200, 3],
        itemsDesktopSmall: [960, 3],
        itemsTablet: [768, 2],
        itemsMobile: [479, 1],
        autoPlay: false,
        rewindNav: false,
        mouseDrag: false,
        touchDrag: true,
        navigation: false,
        pagination: true,
        afterInit: function () {
            $('.landing-page .x-partner-list > ul').find('.owl-wrapper').each(function () {
                var w = $(this).width() / 2;
                $(this).width(w);
                $(this).css('margin', '0 auto');
            });
        },
        afterUpdate: function () {
            $('.landing-page .x-partner-list > ul').find('.owl-wrapper').each(function () {
                var w = $(this).width() / 2;
                $(this).width(w);
                $(this).css('margin', '0 auto');
            });
        }
        //onTranslated: showElement($('.img-fade-in:not(.shown),.text-fade-in:not(.shown)'))
   });

    //initOwlSlider($('.home-page .brand-list'), { items: 4, itemsDesktop: [1199,4], itemsDesktopSmall: [979,3], itemsTablet: [768,3], itemsMobile: [479, 2] });



    var alreadyInit = false;
    if ($(window).width() > 767) {
        alreadyInit = true;
        initOwlSlider($('.home-page .x-product-list > ul'), { items: 5, itemsDesktop: [1086, 4], itemsDesktopSmall: [900, 3], itemsTablet: [735, 2], itemsMobile: [479, 2], rewindNav: false, mouseDrag: false, touchDrag: true });
    }


    // if ($('.home-page').length > 0) {
    //     $(window).resize(_.debounce(function () {
    //         homeProductListCarouselHandler();
    //     }, 100));
    // }

    // function homeProductListCarouselHandler() {

    //     if (($(window).width() < 768)) {
    //         if (alreadyInit) {
    //             var $owlContainer = $('.home-page .x-product-list > ul');

    //             if ($owlContainer.length > 0) {
    //                 $owlContainer.data("owlCarousel").destroy();
    //                 $owlContainer.removeClass('owl-carousel owl-theme');
    //             }

    //             alreadyInit = false;
    //         }
    //     } else {
    //         if (!alreadyInit) {
    //             initOwlSlider($('.home-page .x-product-list > ul'), { items: 5, itemsDesktop: [1086, 4], itemsDesktopSmall: [900, 3], itemsTablet: [735, 2], itemsMobile: [479, 2], rewindNav: false, mouseDrag: false, touchDrag: true });
    //             alreadyInit = true;
    //         }
    //     }
    // }

});

